/* =========================================================
   PRIX PROMO : UNIQUEMENT SUR LES FICHES PRODUIT
   ========================================================= */
   
   document.addEventListener('DOMContentLoaded', function () {
  initMorganSaleBadges();

  document.addEventListener('shopify:section:load', function () {
    initMorganSaleBadges();
  });
});

function initMorganSaleBadges() {

  const priceContainers = document.querySelectorAll('product-price [ref="priceContainer"]');

  priceContainers.forEach(function (container) {

    if (container.querySelector('.morgan-sale-badge')) {
      return;
    }

    const salePriceEl = container.querySelector('.price');
    const comparePriceEl = container.querySelector('.compare-at-price');

    if (!salePriceEl || !comparePriceEl) {
      return;
    }

    const salePrice = parsePrice(salePriceEl.textContent);
    const comparePrice = parsePrice(comparePriceEl.textContent);

    if (!salePrice || !comparePrice || comparePrice <= salePrice) {
      return;
    }

    const discountPercent = Math.round(((comparePrice - salePrice) / comparePrice) * 100);

    if (discountPercent <= 0) {
      return;
    }

    const badge = document.createElement('span');
    badge.className = 'morgan-sale-badge';
    badge.textContent = '-' + discountPercent + ' %';

    container.insertBefore(badge, container.firstChild);

  });
}

function parsePrice(priceText) {

  if (!priceText) return null;

  let cleaned = priceText
    .replace(/\s/g, '')
    .replace(/€/g, '')
    .replace(/\u00A0/g, '')
    .replace(/\./g, '')
    .replace(',', '.');

  const value = parseFloat(cleaned);

  return isNaN(value) ? null : value;
}